import { app } from '../shared';

export const fetchUserPartyTargetingSummary = async () => {
  return app.service('user-party-targeting-summary').find({});
};
